import React from "react";

import { Icon, SelectField } from "@culturehq/components";
import { SelectValue, SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { languages } from "app/utils/aws-languages.json";

type LanguageSelectorProps = {
  onSelectLanguage: (value: null | SelectValue | SelectValueWithCategory) => void;
};

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ onSelectLanguage }) => {
  const languagesOptions = languages.filter(language => !!language.label).map(language => (
    {
      label: language.label || "",
      value: language.language || ""
    }
  ));

  const handleSelectLanguage = (value: null | SelectValue | SelectValueWithCategory) => {
    onSelectLanguage(value);
  };

  return (
    <SelectField
      name="language"
      onChange={handleSelectLanguage}
      options={languagesOptions}
      placeholder="Select a language"
    >
      <Icon icon="translate" />
    </SelectField>
  );
};

export default LanguageSelector;
